import { ButtonBase, Typography } from '@material-ui/core'

import { getTranslate, lang } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { SiteKeys } from '../../types/sitekey'
import useStyles from './styles/SitekeysRow.styles'

interface SitekeysRowDesktopProps {
  sitekeyData: SiteKeys
  loading: boolean
  hasAccessToEditSiteKey: boolean | undefined
}
const SitekeysRowDesktop: React.FC<SitekeysRowDesktopProps> = ({
  sitekeyData,
  hasAccessToEditSiteKey
}) => {
  const classes = useStyles()

  return (
    <ButtonBase
      className={classes.root}
      component={LocalizedLink}
      to={hasAccessToEditSiteKey ? `/sitekeys/${sitekeyData.Id}/edit` : ''}>
      <div>
        <Typography className={classes.text}>
          {getTranslate(sitekeyData.EntityType)}
        </Typography>
      </div>
      <div>
        <Typography className={classes.text}>
          {lang === 'en'
            ? sitekeyData.EntityName
            : sitekeyData.EntityNameTranslatedList[0].value}
        </Typography>
      </div>
      <div>
        <Typography className={classes.text}>
          {sitekeyData.CORSURLs[0]}
        </Typography>
      </div>
      <div>
        <Typography className={classes.text}>{sitekeyData.SiteKey}</Typography>
      </div>
    </ButtonBase>
  )
}
export default SitekeysRowDesktop
